<template>
	<div class="container">
		<b-card bg-variant="light" class="pb-md-3 pl-md-5 bd-content col-md-9 col-xl-8 col-12">
			<b-form-group horizontal
						  breakpoint="lg"
						  label="User qo'shish"
						  label-size="lg"
						  label-class="font-weight-bold"
						  class="mb-0">
				<b-form-group horizontal
							  label="username:"
							  label-class="text-sm-right"
							  label-for="nestedStreet">
					<b-form-input id="nestedStreet" v-model="item.username"></b-form-input>
				</b-form-group>
				<b-form-group horizontal
							  label="password:"
							  label-class="text-sm-right"
							  label-for="nestedCity">
					<b-form-input id="nestedCity" v-model="item.password"></b-form-input>
				</b-form-group>
				<b-form-group horizontal
							  label="status:"
							  label-class="text-sm-right"
							  label-for="nestedState">
					<b-form-select id="nestedState" v-model="item.status"
								   :options="options"></b-form-select>
				</b-form-group>
				<b-button v-on:click.prevent="addItem" type="submit" variant="primary">Submit</b-button>
				<!--<b-form-group horizontal-->
				<!--label="Country:"-->
				<!--label-class="text-sm-right"-->
				<!--label-for="nestedCountry">-->
				<!--<b-form-input id="nestedCountry"></b-form-input>-->
				<!--</b-form-group>-->
				<!--<b-form-group horizontal-->
				<!--label="Ship via:"-->
				<!--label-class="text-sm-right"-->
				<!--class="mb-0">-->
				<!--<b-form-radio-group class="pt-2" :options="['Air', 'Courier', 'Mail']" />-->
				<!--</b-form-group>-->
			</b-form-group>

		</b-card>
	</div>

</template>
<script>

	import {mapActions} from "vuex";
	export default {
		name: "CreateUser",
		/*props: [
			'field'
		],*/
		data: () => {
			return {
				item: {
					username: '',
					password: '',
					status: [
						{value: 'ACTIVE', text: 'ACTIVE'},
						{value: 'INACTIVE', text: 'INACTIVE'},
					]
				},
				title: "bekzod",
				selected: null,
				options: [
					{value: 'ACTIVE', text: 'ACTIVE'},
					{value: 'INACTIVE', text: 'INACTIVE'},
					{value: 'DELETED', text: 'DELETED'},

				],
			}


		},

		methods: {
			...mapActions('users', [
				'createUserStore'
			]),
			async addItem() {
				await this.createUserStore(this.item);
				this.$router.push('/users');

			}
		}
	}
</script>

<style scoped>

</style>
